import {
  GET_TARGET_REQUEST, GET_TARGET_SUCCESS, GET_TARGET_FAIL, CREATE_TARGET_REQUEST, CREATE_TARGET_SUCCESS, CREATE_TARGET_FAIL,
  UPDATE_TARGET_REQUEST, UPDATE_TARGET_SUCCESS, UPDATE_TARGET_FAIL, DELETE_TARGET_REQUEST, DELETE_TARGET_SUCCESS, DELETE_TARGET_FAIL,
} from "../types/targetMasterTypes";



function getTargetReducer(state = { target: [] }, action) {
  switch (action.type) {
    case GET_TARGET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_TARGET_SUCCESS:
      return {
        ...state,
        target: action.payload,
        isLoading: false
      }
    case GET_TARGET_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }
    default:
      return state;
  }
}

function createTargetReducer(state = { createTarget: {} }, action) {
  switch (action.type) {
    case CREATE_TARGET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_TARGET_SUCCESS:
      return {
        ...state,
        createTarget: action.payload,
        isLoading: false
      }
    case CREATE_TARGET_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }
    default:
      return state;
  }
}


function updateTargetReducer(state = { updateTarget: {} }, action) {
  switch (action.type) {
    case UPDATE_TARGET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_TARGET_SUCCESS:
      return {
        ...state,
        updateTarget: action.payload,
        isLoading: false
      }
    case UPDATE_TARGET_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }
    default:
      return state;
  }
}

function deleteTargetReducer(state = { deleteTarget: {} }, action) {
  switch (action.type) {
    case DELETE_TARGET_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_TARGET_SUCCESS:
      return {
        ...state,
        deleteTarget: action.payload,
        isLoading: false
      }
    case DELETE_TARGET_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }
    default:
      return state;
  }
}


export { getTargetReducer, createTargetReducer, updateTargetReducer, deleteTargetReducer }
